import { Component } from '@angular/core';
import { environment } from 'environments/environment';

@Component({
  selector: 'landing-google-play-button',
  templateUrl: './google-play-button.component.html',
  styleUrls: ['./google-play-button.component.scss']
})
export class GooglePlayButtonComponent {
  url = environment.androidAppLink;
}
